const React = require("react");

module.exports = ({children, inline}) => {
    let classProps = "list-unstyled";
    if (inline) {
        classProps += " list-inline"
    }
    return <ul className={classProps}>{children}</ul>
};